export const sounds = {
    'task-complete': new Audio('./assets/task-complete.mp3'),
}